import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import gstIcon from 'assets/dashboard/gstIcon.webp';
import GstConfigDashboard from './gstConfigs';
import GstDashboard from './gstOffers';

export const GST_RESOURCES = {
	gstOffers: 'gstOffers',
	gstConfigs: 'gstConfigs'
};

export const URL = {
	[GST_RESOURCES.gstOffers]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/gst/${GST_RESOURCES.gstOffers}`,
	[GST_RESOURCES.gstConfigs]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/gst/${GST_RESOURCES.gstConfigs}`
};

export const LABEL = {
	[GST_RESOURCES.gstOffers]: 'GST Offers',
	[GST_RESOURCES.gstConfigs]: 'GST Configs'
};

export const COMPONENT = {
	[GST_RESOURCES.gstOffers]: GstDashboard,
	[GST_RESOURCES.gstConfigs]: GstConfigDashboard
};

export const GET_ACTION = {
	[GST_RESOURCES.gstOffers]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getGSTActiveOffers,
	[GST_RESOURCES.gstConfigs]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getGSTConfigs
};

export const IMAGE_SOURCE = {
	[GST_RESOURCES.gstOffers]: gstIcon,
	[GST_RESOURCES.gstConfigs]: gstIcon
};

export type Record = {
	[key: string]: string | number | boolean;
};

export type SelectedUserType = {
	email: string;
	uid: string;
	phone: string;
	userSegment: string;
	addToStatic: boolean;
};

export const ADD_OFFER_ENDPOINT = '/dashboard/finance/gst/gstOffers/create';
export const EDIT_OFFER_ENDPOINT = '/dashboard/finance/gst/gstOffers/edit';
export const BACK_OFFER_ENDPOINT = '/dashboard/finance/gst/gstOffers/list';
export const DETAILS_OFFER_ENDPOINT = '/dashboard/finance/gst/gstOffers/gstOfferDetails';
export const CLONE_OFFER_ENDPOINT = '/dashboard/finance/gst/gstOffers/clone';
export const CREATE_OFFER_URI = '/marketing/dashboard/finance/createGSTOffers';
export const UPDATE_OFFER_URI = '/marketing/dashboard/finance/updateGSTOffers';
export const DISABLE_OFFER_URI = '/marketing/dashboard/finance/disableGSTOffers';
export const GET_OFFER_URI = '/marketing/dashboard/finance/getGSTActiveOffers';
export const ADD_CONFIG_ENDPOINT = '/dashboard/finance/gst/gstConfigs/create';
export const EDIT_CONFIG_ENDPOINT = '/dashboard/finance/gst/gstConfigs/edit';
export const BACK_CONFIG_ENDPOINT = '/dashboard/finance/gst/gstConfigs/list';
export const DETAILS_CONFIG_ENDPOINT = '/dashboard/finance/gst/gstConfigs/gstOfferDetails';
export const CLONE_CONFIG_ENDPOINT = '/dashboard/finance/gst/gstConfigs/clone';
export const CREATE_CONFIG_URI = '/marketing/dashboard/finance/createGSTConfigs';
export const UPDATE_CONFIG_URI = '/marketing/dashboard/finance/updateGSTConfigs';
export const DISABLE_CONFIG_URI = '/marketing/dashboard/finance/removeGSTConfigs';
export const GET_CONFIG_URI = '/marketing/dashboard/finance/getGSTConfigs';
